import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form, Alert } from "reactstrap";
import { get, put, post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate, useParams } from "react-router-dom";
import Loader from "common/loader";
import { SHOW_REASON, UPDATE_REASON, LANGUAGES_SEARCH } from "helpers/api_endpoints";



//meta title
document.title = "Edit Reason";

const EditReason = () => {
    const [loading, setLoading] = useState(true);
    const params = useParams();
    const [id, setid] = useState('');
    const [name, setName] = useState('');
    const [value, setValue] = useState('');
    const [valued, setValued] = useState([]);
    const [named, setNamed] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [status, setStatus] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        post(`${LANGUAGES_SEARCH}`,{status:1})
            .then(response => {
                setLanguages(response.data);
                // console.log(languages);
                setLoading(false);
            })
            .catch(error => {
                navigate('/reasons');
            })
    }, []);
    useEffect(() => {
        get(`${SHOW_REASON}/${params.id}`)
            .then(response => {
                const reason = response.data;
                setid(params.id);
                setValued(reason.valued);
                setNamed(reason.named);
                setValue(reason.value);
                setName(reason.name);
                setStatus(reason.status);
                setLoading(false);
            })
            .catch(error => {
                navigate('/reasons');
            })
    }, [languages]);

    useEffect(() => {
        if(errorMsg != '')
        {
            setTimeout(()=>{setErrorMsg('')}, 3000);
        }
    }, [errorMsg]);

    const handleSubmit = () => { 
        if(!name.title || name.title.length <1)
        {
            setErrorMsg('You must fill at least 1 value');
        }
        put(UPDATE_REASON, { id, name, value, status })
            .then(response => {
                if (response.code == 200) {
                    navigate('/reasons', { state: { successMsg: 'Language Updated SuccessFully' } });
                }
            })
            .catch(error => {
                console.log(error.response);
            })
    }

    const handleName = (languageId,value) => {
        if(!named.title){
            setNamed({"title":[{"1":""}]});
            return;  
        } 
        const ln = named.title.filter(el =>{
            return Object.keys(el)[0] == languageId;
        })
        
        if(ln==undefined || ln.length <1)
        {
            const ob = {};
            ob[languageId] = value;
            named.title.push(ob);
        }
        else
        {
            ln[0][languageId] = value;
        }
        setName(JSON.stringify(named));             
    }
    
    const handleContent = (languageId,value) => {
        if(!valued.title){
            setValued({"title":[{"1":""}]});
            return;  
        } 
        const ln = valued.title.filter(el =>{
            return Object.keys(el)[0] == languageId;
        })
        
        if(ln==undefined || ln.length <1)
        {
            const ob = {};
            ob[languageId] = value;
            valued.title.push(ob);
        }
        else
        {
            ln[0][languageId] = value;
        }
        setValue(JSON.stringify(valued));             
    }
    


    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Reasons" breadcrumbItem="Edit Reason" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        {loading ? <Loader></Loader> :
                                            <Row>



                      
                                            {
                                                languages.map((language, index) => (
                                                    <Row key={index}>
											        {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
                                                    <div className="form-group col-md-4 mt-2">
                                                        <Label className="form-label"><Trans>Title ({language.name})</Trans></Label>
                                                        <Input
                                                            name="name"
                                                            value={named.title?named.title.find(el => {return el[language.id]})?named.title.find(el => {return el[language.id]})[language.id]:'':JSON.stringify(named)}
                                                            className="form-control"
                                                            placeholder="Enter  Name"
                                                            type="text"
                                                            onChange={(e) => handleName(language.id,e.target.value)}
                                                             required={language.id==1||language.id==2?true:false}></Input>
                                                    </div>

                                                    <div className="form-group col-md-4 mt-2">
                                                        <Label className="form-label"><Trans>Reason Content {language.name}</Trans></Label>
                                                        <Input
                                                            name="reason-content-arabic"
                                                            value={valued.title?valued.title.find(el => {return el[language.id]})?valued.title.find(el => {return el[language.id]})[language.id]:'':JSON.stringify(valued)}
                                                            className="form-control"
                                                            placeholder="Enter Content"
                                                            type="text"
                                                            onChange={(e) => handleContent(language.id,e.target.value)}
                                                             required={language.id==1||language.id==2?true:false}></Input>
                                                    </div>

                                                </Row>
                                                ))
                                            }

                                                <div className="form-group col-md-4 mt-2">
                                                    <Label className="form-label"><Trans>Status</Trans></Label>
                                                    <select className="form-control" onChange={(e) => setStatus(e.target.value)}>
                                                        <option value=''></option>
                                                        <option value={1} selected={status == 1}><Trans>Active</Trans></option>
                                                        <option value={0} selected={status != 1}><Trans>Non Active</Trans></option>
                                                    </select>
                                                </div>
                                                <div className="text-center  mt-4">
                                                    <Button type="submit" color="danger">
                                                        <Trans>Submit</Trans>
                                                    </Button>
                                                </div>
                                            </Row>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default EditReason
